import React from "react";
import { Box, Link, Stack, Typography } from "@mui/material";
import { IAP_PRODUCT_ICON_BASE, IAP_PRODUCT_ICONS } from "./iapProductIcons";

const PREVIEW_PX = 168;

/**
 * App Store IAP product images — preview + PNG download.
 */
export default function IapProductIconsPanel() {
    return (
        <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap">
            {IAP_PRODUCT_ICONS.map((product) => {
                const href = `${IAP_PRODUCT_ICON_BASE}/${product.file}`;
                return (
                    <Box
                        key={product.id}
                        sx={{
                            flex: "1 1 260px",
                            minWidth: 240,
                            maxWidth: 340,
                            p: 2,
                            borderRadius: 2,
                            border: "1px solid",
                            borderColor: "divider",
                            bgcolor: "background.paper",
                        }}
                    >
                        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                            {product.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                            {product.summary}
                        </Typography>
                        <Box
                            component="img"
                            src={href}
                            alt={product.name}
                            sx={{
                                display: "block",
                                width: PREVIEW_PX,
                                height: PREVIEW_PX,
                                mx: "auto",
                                mb: 1.5,
                                objectFit: "contain",
                                bgcolor: "#111827",
                                borderRadius: 2,
                            }}
                        />
                        <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: "block", mb: 1, textAlign: "center" }}
                        >
                            public/v4/products/{product.file}
                        </Typography>
                        <Stack direction="row" spacing={1} justifyContent="center">
                            <Link href={href} target="_blank" rel="noopener noreferrer" sx={{ fontWeight: 700 }}>
                                View
                            </Link>
                            <Link href={href} download={product.file} sx={{ fontWeight: 700 }}>
                                Download PNG
                            </Link>
                        </Stack>
                    </Box>
                );
            })}
        </Stack>
    );
}
